export default "__VITE_ASSET__ClsthPxb__"